import cookie from 'cookie-cutter';
import moment from 'moment-timezone';
import { useEffect, useState } from 'react';
import { createIntl } from 'react-intl';

import { cache, importMessages, supportedLocales } from '$Utils';

// hook to wrap react-intl functionality
const useIntlHelper = (options = {}) => {
    const { appName = '', shouldIntl = false, loadOnInit = true } = options;
    let [loading, setLoading] = useState(loadOnInit);
    let [ourIntl, setOurIntl] = useState(null);

    const updateIntl = (newLocale = 'en-US') => {
        // if we shouldn't i18n and already have a default, back out
        if (!shouldIntl && ourIntl) return;

        // if we shouldn't i18n and _don't_ have a default (no appname),
        // warn and just don't fill in messages
        // (the idea is to eventually have messages, but we should wrap a
        // provider where we can to be proactive)
        if (!shouldIntl && !appName) {
            console.warn(
                'Application name should be provided to create an IntlProvider - proceeding with empty provider'
            );
        }

        setLoading(true);
        document.documentElement.lang = newLocale;
        cookie.set('language', newLocale, {
            expires: moment().add(1, 'days'),
            path: '/'
        });
        const messages = appName ? importMessages(appName, newLocale) : {};
        setOurIntl(
            createIntl(
                {
                    locale: newLocale,
                    messages: messages
                },
                cache
            )
        );
        setLoading(false);
    };

    useEffect(() => {
        // set language on load
        const langCookie = cookie.get('language');
        let assumedLocale = langCookie ? langCookie : navigator.language;
        if (!shouldIntl || !supportedLocales.includes(assumedLocale)) {
            // set back to english to prevent pronunciation issues for AT
            assumedLocale = 'en-US';
        }
        updateIntl(assumedLocale);
    }, []);

    return { loading, ourIntl, updateIntl };
};

export default useIntlHelper;
